import { render, staticRenderFns } from "./rental-edit.vue?vue&type=template&id=c4de87f6&scoped=true&"
import script from "./rental-edit.vue?vue&type=script&lang=js&"
export * from "./rental-edit.vue?vue&type=script&lang=js&"
import style0 from "./rental-edit.vue?vue&type=style&index=0&id=c4de87f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4de87f6",
  null
  
)

export default component.exports